/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });

export default class ViewIntroduction {
  static getIntroductionData({ pageNumber, pageSize, type }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/introductions?pageNumber=${pageNumber}&pageSize=${pageSize}&type=${type}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    ViewIntroduction.getIntroductionData.cancel = request.cancel;
    return request;
  }

  static getIntroductionRemarksData({ id }) {
    const accessToken = localStorage.getItem("authToken");
    const request = get(`/api/introductions/${id}/remarks`, {
      accessToken,
    });

    ViewIntroduction.getIntroductionRemarksData.cancel = request.cancel;
    return request;
  }

  static forwardIntroduction({ data, id }) {
    // Transform the payload to rename the keys
    const transformedData = {
      ...data,
      introducedByName: data.introducerName,
      introducedByEmail: data.introducerEmail,
      introducedByMobileNumber: data.introducerMobileNumber,
    };

    // Remove the old keys
    delete transformedData.introducerName;
    delete transformedData.introducerEmail;
    delete transformedData.introducerMobileNumber;

    const accessToken = localStorage.getItem("authToken");
    const request = put(`/api/introductions/${id}/forward`, {
      accessToken,
      data: transformedData,
    });

    ViewIntroduction.forwardIntroduction.cancel = request.cancel;

    return request;
  }

  static addRemark({ data, id }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/introductions/${id}/remarks`, {
      accessToken,
      data,
    });

    ViewIntroduction.addRemark.cancel = request.cancel;

    return request;
  }

  static rejectIntroduction({ data, id }) {
    const accessToken = localStorage.getItem("authToken");
    const request = put(`/api/introductions/${id}/rejection`, {
      accessToken,
      data,
    });

    ViewIntroduction.rejectIntroduction.cancel = request.cancel;

    return request;
  }

  static searchIntroduction(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/introductions/search", {
      accessToken: accessTokenFromLocal,
      data,
    });

    ViewIntroduction.searchIntroduction.cancel = request.cancel;
    return request;
  }

  static getIntroductionPendingTransfer(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/introductions`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
      },
    });

    ViewIntroduction.getIntroductionPendingTransfer.cancel = request.cancel;
    return request;
  }
}
